import { __assign, __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import ErrorBoundary from '../../../ErrorBoundary';
import DeviationDumbView from '../../Dumbo';
import DeviationLink from '../../../Duperbrowse/DeviationLink';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType } from '../../_helpers';
import Overlay from './Overlay';
import PollThumb from './Poll';
import StatusThumb from './Status';
import { BiDataHook } from '../../../biLogger';
import s from './Standard.scss';
var StandardThumb = /** @class */ (function (_super) {
    __extends(StandardThumb, _super);
    function StandardThumb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StandardThumb.prototype.render = function () {
        var type = getDeviationType(this.props.deviation);
        switch (type) {
            case DeviationTypes.POLL:
                return React.createElement(PollThumb, __assign({}, this.props));
            case DeviationTypes.STATUS:
                return React.createElement(StatusThumb, __assign({}, this.props));
            // TODO: add other special cases here
            default:
                return this.renderDefault();
        }
    };
    StandardThumb.prototype.renderDefault = function () {
        var _a = this.props, className = _a.className, deviation = _a.deviation, height = _a.height, responsive = _a.responsive, style = _a.style, width = _a.width;
        return (React.createElement("div", { className: classnames(s['root'], className), style: __assign({ width: width, height: height }, style), "data-hook": BiDataHook.DEVIATION_STD_THUMB },
            React.createElement(ErrorBoundary, null,
                React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, responsive: responsive }),
                React.createElement(DeviationLink, { deviation: deviation, className: s['link'], title: deviation.title, "aria-label": deviation.title },
                    React.createElement("span", null)),
                React.createElement(Overlay, { deviation: deviation, width: width, height: height, className: s['overlay'] }))));
    };
    return StandardThumb;
}(React.Component));
export default StandardThumb;
//# sourceMappingURL=Standard.js.map